import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [LocationVarKey.CostLateFee1, LocationVarKey.CostLateFee2];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Late Fee
      </PageHeader>

      {/* <InputRow {...page}  keyName= {LocationVarKey.LeaseLateFeeAmount} label="Late Fee Amount" /> */}
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.CostLateFee1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.CostLateFee2}
        enableSwitchVar={LocationVarKey.CostLateFee2Enabled}
      />
    </>
  );
}
